import { mount } from 'svelte'
import App from './App.svelte'
import './app.css'
import { i18n, t } from './lib/i18n/index.svelte.js'
import { router } from './lib/router.svelte.js'
import { myLists } from './lib/state/myLists.svelte.js'
import { prefs } from './lib/state/prefs.svelte.js'
import { toasts } from './lib/state/toasts.svelte.js'

i18n.init()
prefs.init()
myLists.init()
router.init()

mount(App, { target: document.getElementById('app') as HTMLElement })

// Offer the update instead of reloading, which would interrupt an edit.
void (async () => {
  try {
    const { registerSW } = await import('virtual:pwa-register')
    const update = registerSW({
      immediate: true,
      onNeedRefresh() {
        toasts.show(t('toast_update_available'), {
          action: { label: t('refresh'), run: () => void update(true) },
          durationMs: 20_000,
        })
      },
    })
  } catch {
    // No service worker in dev, and a failure here must never break the app.
  }
})()
